<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  v-on:keyup.enter="onSearchApartment(1)"
                  class="form-control"
                  :placeholder="$t('customer.owner')"
                  v-model="search.owner_resident"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment(1)"
                  type="text"
                  class="form-control"
                  :placeholder="$t('apartment.apartment_code')"
                  v-model="search.apartment_code"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment(1)"
                  type="number"
                  class="form-control"
                  :placeholder="$t('apartment.fromsize')"
                  v-model="search.fromsize"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  v-on:keyup.enter="onSearchApartment(1)"
                  type="number"
                  class="form-control"
                  :placeholder="$t('apartment.tosize')"
                  v-model="search.tosize"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <lte-section-select2
                  @selectData="onSelectApartmentStatus"
                  @unselectData="onUnselectApartmentStatus"
                  :data="columnApartmentStatus.data_list"
                  :placeHolder="$t('common.status')"
                ></lte-section-select2>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <lte-section-select2
                  @selectData="onSelectApartmentType"
                  @unselectData="onUnselectApartmentType"
                  :data="columnApartmentTypeName.data_list"
                  :placeHolder="$t('apartment.type_name')"
                ></lte-section-select2>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchApartment(1)"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="box box-primary" style="width:100%">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartment.title") }}</b>
              <lte-button
                v-show="false"
                style="float:right;background-color:white !important;"
                type="btn btn-default"
                right_icon="fa fa-retweet"
                @click="onMoveToServiceApartment($event)"
                >{{ $t("apartment.move_to_service_apartment") }}</lte-button
              >
              <lte-button
                style="float:right;"
                type="btn
                btn-primary"
                right_icon="fa
                fa-plus"
                @click="addNew($event)"
                v-if="GET_ACCOUNT_DATA.id === 1 || has_perm('create_apartment')"
                >{{ $t("common.add") }}
              </lte-button>
              <lte-button
                v-if="has_perm('import_apartment') || GET_ACCOUNT_DATA.id == 1"
                style="float:right;"
                type="btn btn btn-success"
                right_icon="fa fa-file-excel-o"
                @click="importExcel($event)"
                >{{ $t("apartment.importExcel") }}</lte-button
              >
              <lte-button
                v-if="has_perm('import_apartment') || GET_ACCOUNT_DATA.id == 1"
                style="float:right;"
                type="btn btn btn-primary"
                right_icon="fa fa-upload"
                @click="exportExcel($event)"
                >{{ $t("common.exportFileExcel") }}</lte-button
              >
            </div>
            <select-option-check
              style="margin-top:-40px;"
              :item="columnsApartment"
              class="dropdown-trigger"
              data-icon="eye"
              @callbackData="onColumnSelect"
            ></select-option-check>
          </div>
          <div class="box-body">
            <!--  -->
            <div class="box-body">
              <apartment-group-filter-component
                ref="apartmentGroupFilterComponent"
                :btnDropDownTitle="btnDropDownTitle"
                :isFilter="isFilterApartmentGroup"
                :numberApartmentInGroup="numberApartmentInGroup"
                @emitFilterApartmentInGroup="emitFilterApartmentInGroup"
                @emitAddApartmentInGroup="emitAddApartmentInGroup"
                @emitDeleteApartmentInGroup="emitDeleteApartmentInGroup"
              />
            </div>
            <!--  -->
            <lte-table
              v-if="has_perm('view_apartment') || GET_ACCOUNT_DATA.id == 1"
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridApartmentDataList"
              :columns="gridColumns"
              search_filter="left-search"
              @actions="crudActions"
              :useFilter="useFilter"
              :actions="
                GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment')
                  ? actions
                  : has_perm('update_apartment')
                  ? [actions[0]]
                  : []
              "
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :useCheckBox="useCheckBox"
              @selectedItems="selectedItems"
            ></lte-table>
          </div>
        </div>
        <div
          class="box-footer clearfix"
          style="display:contents;"
          v-if="has_perm('view_apartment') || GET_ACCOUNT_DATA.id == 1"
        >
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-modal
          v-show="isModalMoveToServiceApartment"
          @onConfirm="onConfirmMoveToResidentApartment"
          @close="closeModalMoveTo"
          v-for="obj in objModalMoveToResidentApartment"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>

    <lte-modal-invoice-general-invoice-detail-pb
      ref="modalInvoiceGeneralInvoiceDetail"
      @callbackInvoiceGeneralInvoiceSuccess="onRefreshInvoiceGeneralInvoiceList"
    ></lte-modal-invoice-general-invoice-detail-pb>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils';
import XLSX from "xlsx";
import SelectOptionCheck from "@/components/SelectOptionCheck.vue";
import sectionselect2 from "@/components/LTESelect2Section";
import constants from "@/lib/constantsData";

import LTEModalInvoiceGeneralInvoiceDetailPB from "@/components/LTEModalInvoiceGeneralInvoiceDetailPB";
import ApartmentGroupFilterComponent from "./ApartmentGroupFilterComponent"

export default {
  name: "ApartmentList",
  data() {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridApartmentDataList: [],
      useFilter: false,
      boxStyle: false,
      useCheckBox: true,
      list_apartment_id: [],
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "common.code", isHidden: true, wrapText: 'nowrap' },
        { text: "apartment.apartment_code", isHidden: true, align: 'center', wrapText: 'nowrap' },
        { text: "apartment.size", isHidden: true },
        { text: "apartment.status", isHidden: true, wrapText: 'nowrap' },
        // { text: "invoice_general_invoice.type_name", isHidden: true },
        { text: "customer.owner", isHidden: true, width: '200px' },
        { text: "customer.headOfAHousehold", isHidden: true, width: '200px' },
        { text: "customer.emergencyContactPerson", isHidden: true, width: '200px' },
        { text: "customer.phone", isHidden: true, wrapText: 'nowrap' },
        // { text: "apartment.apartmentTenant", isHidden: true }
      ],
      columnsApartment: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },
      columnApartmentStatus: {
        data_list: constants.apartmentStatusText,
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      columnApartmentTypeName: {
        data_list: [
          {
            text: "reportLiabilitiesReport.apartmentsForStay",
            id: 1
          },
          {
            text: "reportLiabilitiesReport.apartmentsForRent",
            id: 2
          }
        ],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        apartment: true
      },
      statusSelected: [],
      apartment_type_search: [],
      actions: ["common.modify"
      // , "common.add_retail_service"
      ],
      //hdBackground         : "background-color: #4b646f;color:white;border-bottom:2px solid #f4f4f4;", //00a65a
      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      tblBorder: "border: 1px solid orange",
      originalRecordData: [],
      isModalVisible: false,
      isModalMoveToServiceApartment: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      objModalMoveToResidentApartment: [
        {
          title: "Chuyển Đổi Căn Hộ Tới Căn Hộ Dịch Vụ",
          body:
            "Bạn có chắc chắn muốn chuyển đổi căn hộ tới căn hộ dịch vụ không?",
          buttonNo: "Hủy",
          buttonYes: "Đồng Ý",
          styleType: "default"
        }
      ],
      paginatorItem: {
        commit_function: "GET_APARTMENT_LIST"
      },
      search: {
        code: "",
        apartment_code: "",
        fromsize: "",
        tosize: "",
        status: "",
        owner_resident: ""
      },
      isLoading: false,
      module_id: 4,
      permissions: [],
      exportExcelData: {
        headerList: [
          "apartment.apartment_code",
          "apartment.size",
          "customer.owner",
          "apartment.ownerPhone",
          "apartment.tenant",
          "apartment.tenantPhone",
          "apartment.ownerEmail",
          "apartment.tenantEmail"
        ],
        dataList: [],
        wscols: []
      },
      btnDropDownTitle: 'apartment.apartmentGroupFilterTitle',
      isFilterApartmentGroup: true,
      apartmentGroupIdFilter: [],
      numberApartmentInGroup: 0
    };
  },
  watch: {
    GET_LANG: function() {
      this.onSearchApartment(1)
    },
    GET_APARTMENT_LIST_DATA: function() {
      this.gridApartmentDataList = [];
      this.numberApartmentInGroup = this.PAGINATION.total
      this.GET_APARTMENT_LIST_DATA.forEach((apartment, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = apartment.code;
        let id = apartment.id;
        let apartment_code = apartment.apartment_code;
        let size = apartment.size;
        let status = "";
        if (apartment.status == 1) {
          status = this.$t("apartment_status.not_handover");
        } else if (apartment.status === 2) {
          status = this.$t("apartment_status.handover");
        } else if (apartment.status == 3) {
          status = this.$t("apartment_status.occupied");
        } else if (apartment.status == 4) {
          status = this.$t("apartment_status.not_rented");
        } else if (apartment.status == 5) {
          status = this.$t("apartment_status.rented");
        }
        let full_name_owner = "";
        let ownerPhone = ""
        if (apartment.status != 1) {
          let object_resident = apartment.resident.filter(
            item => item.isOwner === true
          );
          if (object_resident.length > 0) {
            full_name_owner =
              object_resident[0].resident.last_name +
              " " +
              object_resident[0].resident.first_name;
            ownerPhone = object_resident[0].resident.phone
          }
        }
        let tenantData = this.getTenantName(apartment.resident)

        let data = {
          id: id,
          "common.nonumber": nonumber,
          "common.code": code,
          "apartment.apartment_code": apartment_code,
          "apartment.size": size,
          "apartment.status": status,
          "customer.owner": utils.capitalizeFirstInString(
            full_name_owner
          ),
          "customer.emergencyContactPerson": tenantData ? tenantData.last_name + " " + tenantData.first_name : full_name_owner,
          "customer.phone": tenantData ? tenantData.phone : ownerPhone,
          "invoice_general_invoice.type_name":
            apartment.apt_type == 1
              ? this.$t("reportLiabilitiesReport.apartmentsForStay")
              : this.$t("reportLiabilitiesReport.apartmentsForRent"),
          // "apartment.apartmentTenant": this.getTenantName(apartment.resident)
          "customer.headOfAHousehold": tenantData ? tenantData.last_name + " " + tenantData.first_name : full_name_owner,
        };
        this.gridApartmentDataList.push(data);
      });
      this.isLoading = false;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        let newGridColumns = [];
        if (this.gridColumns.length == viewedColumns.length) {
          for (
            let j = 0, sizeOrigin = this.gridColumns.length;
            j < sizeOrigin;
            j++
          ) {
            for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
              if (this.gridColumns[j].text == viewedColumnsKey[i]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = viewedColumnsKey[i];
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
                newGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = newGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
        // update when add columns in table
        else if (this.gridColumns.length != viewedColumnsKey.length) {
          let updateGridColumns = [];
          for (let i = 0; i < this.gridColumns.length; i++) {
            for (let j = 0; j < viewedColumnsKey.length; j++) {
              if (this.gridColumns[i] != viewedColumnsKey[j]) {
                let viewdColumnObject = {};
                viewdColumnObject.text = this.gridColumns[i].text;
                viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[j]];
                updateGridColumns.push(viewdColumnObject);
                break;
              }
            }
          }
          this.gridColumns = updateGridColumns;
          this.columnsApartment.data_list = this.gridColumns;
        }
      }
    },
    GET_CURRENT_ROLE: function() {}
  },
  computed: {
    ...mapGetters([
      "PAGINATION",
      "GET_SNACK_BAR",
      "GET_APARTMENT_LIST_DATA",
      "GET_ACCOUNT_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA",
      "GET_LANG",
      "GET_APARTMENTPERMISSIONS_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    updateSelectedApartmentStatus: function() {
      if (!utils.isNull(this.statusSelected)) {
        for (let j = 0, sizeApartmentStatus = this.columnApartmentStatus.data_list.length; j < sizeApartmentStatus; j++
        ) {
          for (let k = 0, sizeStatusSelected = this.statusSelected.length; k < sizeStatusSelected; k++) {
            if (this.statusSelected[k] == this.columnApartmentStatus.data_list[j].id) {
              this.columnApartmentStatus.data_list[j]["selected"] = "selected";
            }
          }
        }
      }
    },
    onSelectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) == -1) {
        this.statusSelected.push(parseInt(data.id));
      }
    },
    onUnselectApartmentStatus: function(data) {
      if (this.statusSelected.indexOf(parseInt(data.id)) != -1) {
        this.statusSelected.splice(
          this.statusSelected.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onSelectApartmentType: function(data) {
      if (this.apartment_type_search.indexOf(parseInt(data.id)) == -1) {
        this.apartment_type_search.push(parseInt(data.id));
      }
    },
    onUnselectApartmentType: function(data) {
      if (this.apartment_type_search.indexOf(parseInt(data.id)) != -1) {
        this.apartment_type_search.splice(
          this.apartment_type_search.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    onColumnSelect: function(tables) {
      let tableDataObj = {};
      let tableDataObjChild = {};
      tableDataObjChild["tablename"] = "apartmentlist";
      tables.data_list.forEach(element => {
        tableDataObj[element.text] = element.isHidden;
      });
      tableDataObjChild["tablerow"] = tableDataObj;
      this.SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG(tableDataObjChild)
        .then(function() {}.bind(this))
        .catch(function() {}.bind(this));
    },
    onSearchApartment: function(page) {
      this.$router.replace({
        query: {
          apartmentCode: this.search.apartment_code,
          fromSize: this.search.fromsize,
          toSize: this.search.tosize,
          ownerResident: this.search.owner_resident,
          statusSelected: this.statusSelected
        }
      });
      const data = {
        params: {
          page: page,
          apt_type: 1,
          isGetAllApartment: "True",
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          status: this.statusSelected,
          owner_resident: this.search.owner_resident,
          apartment_type_search: this.apartment_type_search,
          apartmentGroupIdFilter: this.apartmentGroupIdFilter
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_LIST(data).then().catch(
        function(error) {
          this.isLoading = false;
          this.ON_SHOW_TOAST({
            message: this.$t("common.please_try_again"),
            styleType: "danger"
          });
        }.bind(this)
      );
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentAdd",
        params: {
          id: 0
        },
        query: {
          apartmentCode: this.search.apartment_code,
          fromSize: this.search.fromsize,
          toSize: this.search.tosize,
          ownerResident: this.search.owner_resident,
          statusSelected: this.statusSelected
        }
      });
    },
    importExcel: function() {
      this.$router.push({
        name: "ApartmentImportExcel",
        params: {
          id: 0
        },
        query: {
          apartmentCode: this.search.apartment_code,
          fromSize: this.search.fromsize,
          toSize: this.search.tosize,
          ownerResident: this.search.owner_resident,
          statusSelected: this.statusSelected
        }
      });
    },
    onRefreshInvoiceGeneralInvoiceList: function() {},
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "ApartmentAdd",
          params: {
            id: recordData.id
          },
          query: {
            apartmentCode: this.search.apartment_code,
            fromSize: this.search.fromsize,
            toSize: this.search.tosize,
            ownerResident: this.search.owner_resident,
            statusSelected: this.statusSelected
          }
        });
      } else if (actionsType == LTEActionTypeEnum.ADD_RETAIL_SERVICE) {
        // Show modal Add
        this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom(
          "INVOICE_GENERAL_INVOICE"
        );

        let object_data_default = {
          purpose: 4,
          apartment_code: recordData["apartment.apartment_code"],
          apartment: recordData["id"]
        };
        this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(
          object_data_default
        );

        this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
      } else {
        if (this.has_perm("delete_apartment") || GET_ACCOUNT_DATA.id == 1) {
          this.originalRecordData = recordData;
          this.isModalVisible = isModalVisible;
        } else {
          alert("Bạn Không Có Quyền Để Xóa");
        }
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_PROPERTY(this.originalRecordData).then(
        function() {
          let currentPage = this.PAGINATION.page;
          let totalPage = this.PAGINATOR.length;
          let page =
            currentPage >= totalPage && this.gridCustomerDataList.length == 1
              ? totalPage - 1
              : currentPage;
          this.onSearchApartment(page)
          this.SUCCESS_TOAST();
        }.bind(this)
      )
      .catch(
        function() {
          this.ERROR_TOAST();
        }.bind(this)
      );
    },
    onPagination: function(data) {
      this.onSearchApartment(data.params.page)
    },
    closeModal() {
      this.isModalVisible = false;
    },
    closeModalMoveTo() {
      this.isModalMoveToServiceApartment = false;
    },
    selectedItems: function(list_apartment_id) {
      if (list_apartment_id.length > 0) {
        this.btnDropDownTitle = 'apartment.addOrRemoveApartmentInGroupTitle'
        this.isFilterApartmentGroup = false
      } else {
        this.btnDropDownTitle = 'apartment.apartmentGroupFilterTitle'
        this.isFilterApartmentGroup = true
      }
      this.list_apartment_id = list_apartment_id;
    },
    onMoveToServiceApartment: function() {
      if (this.list_apartment_id.length <= 0) {
        this.ON_SHOW_TOAST({
          message: "Xin Vui Lòng Chọn 1 Căn Hộ",
          styleType: "danger"
        });
        return;
      }
      this.isModalMoveToServiceApartment = true;
    },
    onConfirmMoveToResidentApartment: function() {
      this.isLoading = true;
      let payload = {
        data: this.list_apartment_id,
        apartment_type: "service_apt"
      };

      this.CHANGE_RESIDENT_TO_SERVICE_APARTMENT(payload)
        .then(
          function() {
            this.SUCCESS_TOAST();
            this.isLoading = false;
            this.isModalMoveToServiceApartment = false;
            const filter = {
              params: {
                page: 1,
                apt_type: 1,
                isGetAllApartment: "True",
                apartment_code: this.search.apartment_code,
                from_size: this.search.fromsize,
                to_size: this.search.tosize,
                owner_resident: this.search.owner_resident,
                status: this.statusSelected,
                apartment_type_search: this.apartment_type_search
              }
            };
            this.isLoading = true;
            this.GET_APARTMENT_LIST(filter).then().catch(
              function(error) {
                this.isLoading = false;
                this.ON_SHOW_TOAST({
                  message: this.$t("common.please_try_again"),
                  styleType: "danger"
                });
              }.bind(this)
            );
          }.bind(this)
        )
        .catch(
          function(error) {
            this.ON_SHOW_TOAST({
              message: this.messages[error.response.data.message],
              styleType: "danger"
            });
            this.isLoading = false;
          }.bind(this)
        );
    },
    getTenantName: function (residentList) {
      let resultData = null
      let index = residentList.findIndex(x => x.isTenant && x.relationship_to == null)
      resultData = index != -1 ? residentList[index].resident: null
      return resultData
    },
    // 
    exportExcel: function() {
      const data = {
        params: {
          apt_type: 1,
          isGetAllApartment: "True",
          asset: "asset",
          apartment_code: this.search.apartment_code,
          from_size: this.search.fromsize,
          to_size: this.search.tosize,
          status: this.statusSelected,
          owner_resident: this.search.owner_resident,
          apartment_type_search: this.apartment_type_search
        }
      };
      this.isLoading = true;
      this.GET_APARTMENT_LIST(data).then(
        async function(res) {
          this.isLoading = false;
          let data = res.data
          let dataList = this.getDataExcelJson(
            this.exportExcelData.headerList,
            data
          );
          await this.createExcelFile(dataList);
        }.bind(this)
      )
      .catch(
        function(error) {
          this.isLoading = false;
        }.bind(this)
      );
    },
    getDataExcelJson: function(headerList, dataList) {
      let resultList = [];
      let apartmentCodeHeader = headerList[0];
      let apartmentSizeHeader = headerList[1];
      let ownerNameHeader = headerList[2];
      let ownerPhoneHeader = headerList[3];
      let tenantNameHeader = headerList[4];
      let tenantPhoneHeader = headerList[5];
      let ownerEmailHeader = headerList[6];
      let tenantEmailHeader = headerList[7];

      dataList.forEach(data => {
        let full_name_owner = "";
        let ownerPhone = ""
        let ownerEmail = ""
        if (data.status != 1) {
          let object_resident = data.resident.filter(
            item => item.isOwner === true
          );
          if (object_resident.length > 0) {
            full_name_owner = object_resident[0].resident.last_name + " " + object_resident[0].resident.first_name;
            ownerPhone = object_resident[0].resident.phone
            ownerEmail = object_resident[0].resident.email
          }
        }
        let tenantData = this.getTenantName(data.resident)
        let item = {
          [this.$t(apartmentCodeHeader)]: data.apartment_code,
          [this.$t(apartmentSizeHeader)]: data.size,
          [this.$t(ownerNameHeader)]: full_name_owner,
          [this.$t(ownerPhoneHeader)]: ownerPhone,
          [this.$t(ownerEmailHeader)]: ownerEmail,
          [this.$t(tenantNameHeader)]: tenantData !== null ? tenantData.last_name + " " + tenantData.first_name : null,
          [this.$t(tenantPhoneHeader)]: tenantData !== null ? tenantData.phone : null,
          [this.$t(tenantEmailHeader)]: tenantData !== null ? tenantData.email : null
        }
        resultList.push(item)
        this.getWscols(item)
      });
      return resultList;
    },
    createExcelFile: function(jsonData) {
      let data_list = [];

      data_list = jsonData;
      // export json to Worksheet of Excel
      // only array possible
      var excelFileData = XLSX.utils.json_to_sheet(data_list);
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)


      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, excelFileData, "apartmentList"); // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      excelFileData['!cols'] = this.exportExcelData.wscols

      // export Excel file
      XLSX.writeFile(wb, "ApartmentList.xlsx"); // name of the file is 'book.xlsx'
    },
    getWscols: function(obj) {
      let wscolsLength = this.exportExcelData.wscols.length
      let cellWidthDefault = 10
      if (wscolsLength === 0) {
        let objKeys = Object.keys(obj)
        objKeys.forEach(k=> {
          let cellWidth = utils.isEmptyString(obj[k]) 
            ? cellWidthDefault
            : obj[k].toString().length > cellWidthDefault ? obj[k].toString().length : cellWidthDefault
          this.exportExcelData.wscols.push(
            {wch: cellWidth})
        })
      } else {
        let objKeys = Object.keys(obj)
        objKeys.forEach((k, i)=> {
          if (!utils.isEmptyString(obj[k]) && obj[k].toString().length > this.exportExcelData.wscols[i].wch) {
            this.exportExcelData.wscols[i].wch = obj[k].toString().length
          }
        })
      }
    },
    emitFilterApartmentInGroup: function(data) {
      this.apartmentGroupIdFilter = data
      this.onSearchApartment(1)
    },
    emitAddApartmentInGroup: function(data) {
      if (data.length > 0) {
        this.addApartmentInGroup(data)
      }
    },
    addApartmentInGroup: function(apartmentGroup) {
      let data = {
        apartmentIds: this.list_apartment_id,
        apartmentGroupIds: apartmentGroup
      }
      this.isLoading = true;
      this.POST_APARTMENT_IN_GROUP(data)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
            // this.$refs.lte_table.removeSelected();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    emitDeleteApartmentInGroup: function(data) {
      if (data.length > 0) {
        this.deleteApartmentListInGroup(data)
      }
    },
    deleteApartmentListInGroup: function(apartmentGroup) {
      let data = {
        apartmentIds: this.list_apartment_id,
        apartmentGroupIds: apartmentGroup
      }
      this.isLoading = true;
      this.DELETE_APARTMENT_LIST_IN_GROUP(data)
        .then(
          function() {
            this.isLoading = false;
            this.SUCCESS_TOAST();
            this.$refs.lte_table.removeSelected();
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_LIST",
      "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_PERMISSIONS_BYMODULE",
      "ON_SHOW_TOAST",
      "CHANGE_RESIDENT_TO_SERVICE_APARTMENT",
      "POST_APARTMENT_IN_GROUP",
      "DELETE_APARTMENT_LIST_IN_GROUP",
      "DELETE_PROPERTY"
    ])
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    "select-option-check": SelectOptionCheck,
    "lte-section-select2": sectionselect2,
    "lte-modal-invoice-general-invoice-detail-pb": LTEModalInvoiceGeneralInvoiceDetailPB,
    ApartmentGroupFilterComponent
  },
  mounted() {
    let routeQuery = this.$route.query
    this.search.apartment_code = routeQuery && routeQuery.apartmentCode;
    this.search.fromsize = routeQuery && routeQuery.fromSize;
    this.search.tosize = routeQuery && routeQuery.toSize;
    this.search.owner_resident = routeQuery && routeQuery.ownerResident;
    this.statusSelected = !utils.isNull(routeQuery && routeQuery.statusSelected)
      ? routeQuery && routeQuery.statusSelected : [];
    const data = {
      params: {
        page: 1,
        isGetAllApartment: "True",
        apt_type: 1,
        apartment_code: this.search.apartment_code,
        from_size: this.search.fromsize,
        to_size: this.search.tosize,
        owner_resident: this.search.owner_resident,
        status: this.statusSelected,
        apartment_type_search: this.apartment_type_search
      }
    };
    this.isLoading = true;
    this.GET_APARTMENT_LIST(data).then().catch(
      function(error) {
        this.isLoading = false;
        this.ON_SHOW_TOAST({
          message: error.response.data.message,
          styleType: "danger"
        });
      }.bind(this)
    );
    this.columnsApartment.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "apartmentlist"
      }
    };

    this.GET_PERMISSIONS_BYMODULE({
      params: {
        module_id: 4
      }
    });

    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
    this.updateSelectedApartmentStatus()
  }
};
</script>

<style scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.size-180 {
  width: 180px;
}

.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}
.select-option-status {
  margin-top: -12px;
  display: inline-block;
}

@media only screen and (max-width: 1000px) {
  .select-option-status {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-status {
    float: none;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentList.vue